import script from "./Contact.vue?vue&type=script&lang=ts&setup=true"
export * from "./Contact.vue?vue&type=script&lang=ts&setup=true"

import "./Contact.vue?vue&type=style&index=0&id=2492c32c&lang=scss&scoped=true"

import exportComponent from "D:\\project\\new_fd_yun\\website-dev-En\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2492c32c"]])

export default __exports__